export const hyper = {
  en: {
    hyper_payment_management_card: 'Managing Payment Cards',
    hyper_payment_card: 'Payment card',
    hyper_payment_change_card: 'Change card',
    button_back: 'Go back',
  },
  ko: {
    hyper_payment_management_card: '결제 카드 관리',
    hyper_payment_card: '결제 카드',
    hyper_payment_change_card: '카드 변경',
    button_back: '돌아가기',
  },
  ja: {
    hyper_payment_management_card: '決済カード管理',
    hyper_payment_card: '決済カード',
    hyper_payment_change_card: 'カード変更',
    button_back: '帰る',
  },
  vn: {
    hyper_payment_management_card: 'Quản lý thẻ thanh toán',
    hyper_payment_card: 'thẻ thanh toán',
    hyper_payment_change_card: 'Đổi thẻ',
    button_back: 'sự quay trở lại',
  },
}
